
import { Component, Mixins, Vue } from 'vue-property-decorator';
import { Collapse, CollapseItem, Card } from 'element-ui';
import BsMixin from '@/views/Home/mixins/bsMixin';
import api from '@/api/user';

  @Component({
    components: {
      Collapse,
      CollapseItem,
      Card,
    },
  })

export default class cardList extends Mixins(BsMixin) {
  private activeName = '';

  private activeNames = '';

  private courseList:any = [];

  private chapters: any = [];

  private projectList: any = [];

  private index: number = 0;

  public $refs!: {
    myCourse: Element;
  }

  mounted() {
    this.initBS(this.$refs.myCourse);
    api.getCourseById(this.$route.params.pid).then((res: any) => {
      this.courseList = res;
    });
  }

  handleChange(v: any) {
    this.index = v;
    this.chapters = [];
    this.activeNames = '';
    api.getAttendSchedule(
      this.$route.params.pid,
      this.courseList[v].classCourseId,
    ).then((res: any) => {
      this.chapters = res;
    });
  }

  handleChapterChange(v: any) {
    this.projectList = [];
    api.getProject(
      this.$route.params.pid,
      this.chapters[v].classCourseTimeId,
      this.courseList[this.index].courseType,
    ).then((res: any) => {
      this.projectList = res;
    });
  }

  /* eslint-disable class-methods-use-this */
  getPath(item: any) {
    if (item.imagePath) return item.imagePath;
    return require('@/assets/imgs/login_bg.png');
  }

  handleClick(item: any) {
    if (item.version === 2) {
      window.open(`${process.env.VUE_APP_SCRATCH_2X}${item.pid}`);
    }
    if (item.version === 3) {
      window.open(`${process.env.VUE_APP_SCRATCH_3X}${item.pid}`);
    }
  }
}
